<template>
<Widgest isOpenAll widgestType="outer" v-if="totalCount>0" >
  <template v-slot:title>{{$t('report.static.url_link.title')}}</template>
  <div >
    <SandTable style="padding-bottom: 24px;" class="skill-urls-table" :data="tableConfig" />
    <div class="pagination-wrap">
      <Pagination
        :totalSize="totalCount"
        :current_page="currentPage"
        :pageSizes="[10, 50, 100, 150, 200]"
        :page-size="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</Widgest>

</template>

<script setup>
import { t } from 'app/i18n'
import { getTaskReportStaticURLs } from 'services/report'

import Pagination from '@/components/common/Pagination'
import SandTable from '@/components/report/sandTable'

import { defineProps, onMounted, reactive, toRefs, computed } from 'vue'
const props = defineProps({
  taskid: {
    type: Number
  }
})

const state = reactive({
  extractURLLInks: [],
  pageSize: 50,
  currentPage: 1,
  loading: true,
  totalCount: 0
})
const { extractURLLInks, pageSize, currentPage, loading, totalCount } = toRefs(state)
const { taskid } = toRefs(props)

onMounted(() => {
  requestExtractURLs()
})

const columnData = [
  { prop: 'url', label: 'URL', align: 'left', col: 3 },
  { prop: 'source', label: t('report.analyse.mitre_att.dialog.source'), align: 'left', width: '200' }
]

const tableConfig = computed(() => {
  const list = Array.isArray(extractURLLInks.value) ? extractURLLInks.value : []
  return {
    columnData,
    tableData: list
  }
})

async function requestExtractURLs(isload) {
  if (isload) loading.value = true
  if (!taskid.value) return
  const result = await getTaskReportStaticURLs(taskid.value, {
    page: currentPage.value,
    size: pageSize.value
  })
  extractURLLInks.value = result?.extract_urls || []
  totalCount.value = result?.count || 0
  loading.value = false
}

function handleCurrentChange(page) {
  currentPage.value = page
  requestExtractURLs(true)
}

function handleSizeChange(size) {
  pageSize.value = size
  currentPage.value = 1
  requestExtractURLs(true)
}

</script>

<style lang="scss" scoped>
.pagination-wrap {
  padding-bottom: 24px;
  margin-right: -20px;
}
</style>
